import { render, staticRenderFns } from "./ClientEditScoreAndSocialDate.vue?vue&type=template&id=4a249b7c"
import script from "./ClientEditScoreAndSocialDate.vue?vue&type=script&lang=js"
export * from "./ClientEditScoreAndSocialDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports